import { render, staticRenderFns } from "./BrandingKit.vue?vue&type=template&id=03dc93c5&scoped=true&"
import script from "./BrandingKit.vue?vue&type=script&lang=ts&"
export * from "./BrandingKit.vue?vue&type=script&lang=ts&"
import style0 from "./BrandingKit.vue?vue&type=style&index=0&id=03dc93c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dc93c5",
  null
  
)

export default component.exports